export default {
    methods: {
        getNotenDescription(werk, komponist, ausgabe, notentyp) {
            var str = `${werk}`;
            if (komponist) {
                str = `${komponist}: ${str}`;
            }
            if (ausgabe) {
                str = `${str} (${ausgabe})`;
            }
            if (notentyp) {
                str = `${str} - ${notentyp}`;
            }
            return str;
        },
    },
};
